import { AutocompleteInput, SelectInput, ReferenceInput } from 'react-admin';
import { TurnReferencesEnum } from '@/types/turn-enums';
import { PER_PAGE, SORT_OPTIONS } from './constants';
import { StateInputProps } from './types';

const StateInput = ({
  combobox = false,
  disabled,
  label = 'State',
  filter = {},
  include_prefix = true,
  source,
  validate,
  ...props
}: StateInputProps) => {
  const computedFilter = { ...filter };
  const Input = combobox ? AutocompleteInput : SelectInput;

  if (!include_prefix) computedFilter.include_prefix = 'False';

  return (
    <ReferenceInput
      filter={computedFilter}
      perPage={PER_PAGE}
      reference={TurnReferencesEnum.AdminStates}
      sort={SORT_OPTIONS}
      source={source}
      {...props}
    >
      <Input
        disabled={disabled}
        label={label}
        optionText="name"
        optionValue="id"
        translateChoice={false}
        validate={validate}
      />
    </ReferenceInput>
  );
};

export default StateInput;
